import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { FindAPDFiltersModel } from "../../redux/reducers/filters-reducer";
import { updateTextFilter } from "../../redux/actions/actions";
import { TextDropDownItem } from "./filter-dropdown-text-option";
import { FindAPDSettingsModel } from "../../redux/reducers/find-a-pd-settings";

interface ExternalProps {
    filterName: string;
    placeholderText: string;
    filterLabel: string;
    data: string[];
}

interface DispatchToProps {
    updateTextFilter: (filterName: string, filterValue: string) => any;
}

type TextDropdownProps = ExternalProps & DispatchToProps ;




export class FilterDropdownTextComponent extends React.Component<TextDropdownProps, any> {
    constructor(props: TextDropdownProps) {
        super(props);
    }

    dropdownChangeEvent(event) {
        this.props.updateTextFilter(this.props.filterName, event.target.value);
    }

    render() {
        return (
            <div className="find-a-pd-filters-panel-item">
                <label htmlFor="mileRadius">{this.props.filterLabel}</label>
                <div className="find-a-pd-filters-option">
                    <select id={this.props.filterName} defaultValue={this.props.placeholderText} onChange={this.dropdownChangeEvent.bind(this)} >
                        <option value="">{this.props.placeholderText}</option>
                        {
                            this.props.data.map(item => <TextDropDownItem key={item.valueOf()} text={item} value={item} />)
                        } 
                    </select>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDFiltersModel>): DispatchToProps {
    return {
        updateTextFilter: (filterName: string, filterValue: string) => dispatch(updateTextFilter(filterName, filterValue))
    }
}

export default connect<null, DispatchToProps, ExternalProps>(null, mapDispatchToProps)(FilterDropdownTextComponent);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/filters/filter-dropdown-text.tsx